import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { ExternalLink, X } from "lucide-react";

const storeLinks = [
  {
    name: "DOLO MERCH — THE FULL COLLECTION",
    detail: "Every official drop in one place · igotism.com",
    url: "https://igotism.com/collections/dolo-merch",
    testId: "store-link-dolo-merch",
  },
];

const editions = [
  { name: "DOLO VOL.1 — INDIE PRINT / SINGLE ISSUE", detail: "~24 pages · $7.00 — the print run is in transit." },
  { name: "DOLO VOL.1 — DIGITAL SINGLE CHAPTER", detail: "~24 pages · $1.99 — the route is decrypting." },
];

export function OrderButton({ children = "[ ORDER VOL. 1 ]", className = "button button-primary", testId = "order-button" }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (event) => event.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open]);

  // global hook so ticker plugs can open the store from anywhere
  useEffect(() => {
    if (window.__openStore) return undefined;
    window.__openStore = () => setOpen(true);
    return () => {
      delete window.__openStore;
    };
  }, []);

  const modal = (
    <AnimatePresence>
      {open ? (
        <motion.div
          className="order-modal-backdrop"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={() => setOpen(false)}
          data-testid={`${testId}-backdrop`}
        >
          <motion.div
            role="dialog"
            aria-modal="true"
            aria-labelledby={`${testId}-title`}
            className="order-modal"
            initial={{ opacity: 0, y: 28, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 18, scale: 0.97 }}
            transition={{ duration: 0.28, ease: [0.22, 1, 0.36, 1] }}
            onClick={(event) => event.stopPropagation()}
            data-testid={`${testId}-modal`}
          >
            <button
              type="button"
              className="modal-close"
              onClick={() => setOpen(false)}
              data-testid={`${testId}-close-button`}
              aria-label="Close order links"
            >
              <X size={18} />
            </button>
            <p className="eyebrow">SUPPLY ROUTE</p>
            <h3 id={`${testId}-title`}>OFFICIAL STORE ONLINE</h3>
            <p>
              The first official drops are live. Grab them before the wasteland does.
            </p>
            <div className="edition-list">
              {storeLinks.map((item, index) => (
                <a
                  className="edition-row edition-live"
                  key={item.name}
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ "--i": index }}
                  data-testid={item.testId}
                >
                  <span>
                    {item.name} <ExternalLink size={13} />
                  </span>
                  <small>{item.detail}</small>
                  <em className="edition-live-tag">SHOP NOW</em>
                </a>
              ))}
              {editions.map((edition, index) => (
                <div
                  className="edition-row"
                  key={edition.name}
                  style={{ "--i": storeLinks.length + index }}
                  data-testid={`${edition.name.toLowerCase().replaceAll(" ", "-")}-row`}
                >
                  <span>{edition.name}</span>
                  <small>{edition.detail}</small>
                  <em className="edition-soon-tag">COMING SOON</em>
                </div>
              ))}
            </div>
          </motion.div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );

  return (
    <>
      <button
        type="button"
        className={className}
        onClick={() => setOpen(true)}
        data-testid={testId}
        aria-haspopup="dialog"
        aria-expanded={open}
      >
        {children}
      </button>
      {createPortal(modal, document.body)}
    </>
  );
}
